/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Series_TitleInputs */

const fr_series_title = /** @type {(inputs: Series_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

/**

* @param {Series_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const series_title = /** @type {((inputs?: Series_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Series_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_series_title(inputs)
});